import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const UEatContext = createContext({ enabled: false, url: '', label_fr: '', label_en: '', banner_message_fr: '', banner_message_en: '', refresh: () => {} });

export function UEatProvider({ children }) {
  const [settings, setSettings] = useState({ enabled: false, url: '', label_fr: 'Commander via UEat', label_en: 'Order via UEat', banner_message_fr: '', banner_message_en: '' });

  const refresh = () => {
    axios.get(`${API}/site-content/ueat`).then(r => setSettings(r.data)).catch(() => {});
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <UEatContext.Provider value={{ ...settings, refresh }}>
      {children}
    </UEatContext.Provider>
  );
}

export function useUEat() {
  return useContext(UEatContext);
}
